import React from 'react';
import FPHtmlViewer from 'UI/components/atoms/FPHtmlViewer';

import { useStyles } from './styles';
import { highlightText } from './utils';

/**
 * @typedef {Object} HighlightBoxProps
 * @property {string[]} highlightData
 * @property {string} text
 */

/**
 * @param {HighlightBoxProps} props
 */
const HighlightBox = ({ text, highlightData }) => {
  const classes = useStyles();
  const content = highlightText(text, highlightData);
  return <FPHtmlViewer className={classes.wrapperMarker} content={content} />;
};

HighlightBox.defaultProps = {
  text: null
};

export default HighlightBox;
